export const toggleBoolean = (prev: boolean) => !prev;

const isValidArrayIndex = (arr: any[], idx: number) => {
  return !(idx < 0 || idx >= arr.length);
};

export function addValueAtIndex(arr: any[], idx: number, value: any) {
  if (!isValidArrayIndex(arr, idx) && idx !== arr.length) {
    throw new Error(`Cannot add value. Array index out of bounds.`);
  }
  return [...arr.slice(0, idx), value, ...arr.slice(idx)];
}

export function replaceValueAtIndex(arr: any[], idx: number, newValue: any) {
  if (!isValidArrayIndex(arr, idx)) {
    throw new Error(`Cannot replace value. Array index out of bounds.`);
  }
  return [...arr.slice(0, idx), newValue, ...arr.slice(idx + 1)];
}

export function updateValueAtIndex(arr: any[], idx: number, updater: any) {
  if (!isValidArrayIndex(arr, idx)) {
    throw new Error(`Cannot update value. Array index out of bounds.`);
  }
  return [...arr.slice(0, idx), updater(arr[idx]), ...arr.slice(idx + 1)];
}

export function removeValueAtIndex(arr: any[], idx: number) {
  if (!isValidArrayIndex(arr, idx)) {
    throw new Error(`Cannot remove value. Array index out of bounds.`);
  }
  return [...arr.slice(0, idx), ...arr.slice(idx + 1)];
}

export function decimalToPercentage(decimal: any) {
  if (decimal === 0) {
    return 0;
  } else {
    return (decimal * 100);
  }
}

export function addThousandsSeparator(input: string | number | undefined) {
  if(!input) return "";
  // Convert the input to a string
  let numberStr = String(input);

  // Add commas as thousands separators
  numberStr = numberStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return numberStr;
}

export function hideWalletAddress(walletAddress: string) {
  return (
    walletAddress.substring(0, 5) +
    "..." +
    walletAddress.substring(walletAddress?.length - 4, walletAddress?.length)
  );
}

export function reload() {
  if(typeof window !== 'undefined') {
    window.location.reload();
  }
}

export function getWindow() {
  if(typeof window !== 'undefined') {
    return window;
  }
}